document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.amazing-checkbox')) {
		const checkBoxDiagrams = document.getElementById('checkBoxDiagrams')
		const amazingcheckbox = document.querySelector('.amazing-checkbox')

		const realizationProEffects = document.getElementById('realization-pro-effects')
		const heightNav = document.querySelector('.navbar-before').offsetHeight
		const positionEfects = realizationProEffects.scrollHeight
		amazingcheckbox.addEventListener('click', function () {
			activeCheckBox(checkBoxDiagrams)
			setTimeout(activeEfects, 800)
		})

		window.addEventListener('scroll', function () {
			if (window.pageYOffset >= (positionEfects - heightNav - 250)) {
				activeEfects()
			}
		})

		const activeDiagrams = function (checkBox) {
			if (checkBox.checked === true) {
				const elementsDiagrams = [...document.querySelectorAll('.diagrams__effects-item')]
				elementsDiagrams.forEach(e => {
					e.classList.add('active')
				})
				checkBox.disabled = true
			}
		}

		const activeCheckBox = function (checkBox) {
			checkBox.checked = true
		}

		const activeEfects = function () {
			checkBoxDiagrams.checked = true
			activeDiagrams(checkBoxDiagrams)
		}

		if (window.pageYOffset >= (positionEfects - heightNav)) {
			activeEfects()
		}
	}
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/realization-diagrams/script.js